export const validate = {
  // 验证邮箱
  isEmail (email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  },

  // 验证手机号
  isPhone (phone) {
    const phoneRegex = /^1[3-9]\d{9}$/
    return phoneRegex.test(phone)
  },

  // 验证URL
  isUrl (url) {
    try {
      const urlObj = new URL(url)
      return !!urlObj
    } catch (err) {
      return false
    }
  },

  // 验证文件大小
  isValidFileSize (file, maxSize = 10 * 1024 * 1024) {
    return file.size <= maxSize
  },

  // 验证文件类型
  isValidFileType (file, allowedTypes = ['image/jpeg', 'image/png', 'image/gif']) {
    return allowedTypes.includes(file.type)
  },

  // 验证必填字段
  isRequired (value) {
    return value !== null && value !== undefined && value !== ''
  },

  // 验证数字
  isNumber (value) {
    return !isNaN(parseFloat(value)) && isFinite(value)
  },

  // 验证正整数
  isPositiveInteger (value) {
    return Number.isInteger(Number(value)) && Number(value) > 0
  }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js